import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyTrades } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./TradingFeeReportPage.css";

const TradingFeeReportPage = () => {
  const [trades] = useState(dummyTrades);
  const [search, setSearch] = useState("");

  const filtered = trades.filter(
    (t) =>
      t.order_id?.toLowerCase().includes(search.toLowerCase()) ||
      t.user_email?.toLowerCase().includes(search.toLowerCase()) ||
      `${t.main_currency}/${t.currency}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Market Trades</span>
          </p>
          <h1 className="dashboard-hero__title">Trading Fee Report</h1>
          <p className="dashboard-hero__subtitle">
            View market trades and fee reports
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-chart-line" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="tradingfee-section">
          <div className="tradingfee-section__header">
            <div className="tradingfee-section__title-wrap">
              <span className="tradingfee-section__icon">
                <i className="fas fa-exchange-alt" />
              </span>
              <h2 className="tradingfee-section__title">Market Trades</h2>
            </div>
            <div className="tradingfee-section__stats">
              <span className="tradingfee-stat">
                <strong>{trades.length}</strong> Trades
              </span>
            </div>
          </div>
          <div className="tradingfee-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by order ID, email or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="tradingfee-search-input"
            />
          </div>
          <div className="tradingfee-table-wrap">
            <table className="tradingfee-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Order ID</th>
                  <th>User Email</th>
                  <th>Mobile</th>
                  <th>Pair</th>
                  <th>Side</th>
                  <th>Order Type</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Fee</th>
                  <th>TDS</th>
                  <th>Counter User</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td>{row.time}</td>
                    <td><span className="tradingfee-order-id">{row.order_id}</span></td>
                    <td>{row.user_email}</td>
                    <td>{row.user_mobileNumber}</td>
                    <td><strong>{row.main_currency}/{row.currency}</strong></td>
                    <td>
                      <span className={`tradingfee-side tradingfee-side--${row.side?.toLowerCase()}`}>
                        {row.side}
                      </span>
                    </td>
                    <td>{row.order_type}</td>
                    <td>{typeof row.price === "number" ? row.price.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : row.price}</td>
                    <td>{typeof row.quantity === "number" ? row.quantity.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.quantity}</td>
                    <td>{typeof row.fee === "number" ? row.fee.toLocaleString("en-IN", { minimumFractionDigits: 6 }) : row.fee}</td>
                    <td>{row.tds ?? "0"}</td>
                    <td><span className="tradingfee-counter">{row.counter_user}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="tradingfee-empty">No trades match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default TradingFeeReportPage;
